module.exports = "pegasus/assets/circle-youtube.png";